import { type } from 'os';
import React, { useState,useEffect } from 'react';
import './index.less';
import {
    Input,
    Button,
} from 'antd';
import {
    SearchOutlined,
} from '@ant-design/icons';
import { AgriAlertClearIcon } from '@/resource/IconComponentSets';

interface IProps {
  children?: React.ReactElement | React.ReactElement[] | string
  className?: string
  GetAnalyses?: (param:string) => void
  onClick?: () => void
  placeholder?:string
  onChange?: (text) => void
}

export default function HeaderSearch(props: IProps ) {
    const [searchParam,setSearchParam] = useState<string>('');
    const {
        className,
    } = props;
    const searchKeyDown = (e)=>{
        setSearchParam(e.target.value);
        if(e.key==='Enter'){
            props.GetAnalyses(searchParam);
        }
    };
    const [searchText,setSearchText]=useState<string>('');
    const onChangeForText=(e)=>{
        console.log('on chang:',e.target.value);
        setSearchText(e.target.value);
    };
    const clearSearch=()=>{
        setSearchText('');
        props.GetAnalyses('');
    };

    return (
        <div className='agriAlertSearch'>
            <h3 className={`soliHeader ${className}`}>
            <Input size="large"
                placeholder={props.placeholder}
                className='headerSearch'
                value={searchText}
                onBlur={(e:any)=>{
                    if(e.target?.value.length==0){
                        props.GetAnalyses('');
                    }
                }}
                onKeyUp = {(e:any)=>{
                    searchKeyDown(e);
                }}
                onChange={onChangeForText}
                prefix={<SearchOutlined />}/>
            {(searchText!=='') && (<span
                style={{
                    position:'absolute',
                    top:15,
                    right:91,
                    zIndex:9,
                    border:'none'
                }}
                onClick={clearSearch}><AgriAlertClearIcon /></span>)}
            {searchParam.length>=0&&<Button
                type="default"
                style={{
                    position:'absolute',
                    top:9,
                    right:15,
                    zIndex:9,
                    background:'#59B948',
                    color:'#fff',
                    borderRadius:'4px'
                }}
                onClick={e=>{
                    props.GetAnalyses(searchParam);
                }}>
                Search
            </Button>}
            </h3>
        </div>
    );
}